import { render, staticRenderFns } from "./vehiclesTable.vue?vue&type=template&id=52c71f89"
import script from "./vehiclesTable.vue?vue&type=script&lang=js"
export * from "./vehiclesTable.vue?vue&type=script&lang=js"
import style0 from "./vehiclesTable.vue?vue&type=style&index=0&id=52c71f89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports